// Native vs web platform detection.
// Capacitor sets `window.Capacitor` only when the app is running inside a native shell.
// On web (PWA / browser) this file detects gracefully and we fall back to localStorage/IDB.

let cachedIsNative = null;
let cachedPlatform = null;

export function isNativePlatform() {
  if (cachedIsNative !== null) return cachedIsNative;
  try {
    const cap = typeof window !== 'undefined' ? window.Capacitor : null;
    cachedIsNative = !!(cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform());
  } catch {
    cachedIsNative = false;
  }
  return cachedIsNative;
}

export function getPlatform() {
  if (cachedPlatform !== null) return cachedPlatform;
  try {
    const cap = typeof window !== 'undefined' ? window.Capacitor : null;
    cachedPlatform = (cap && typeof cap.getPlatform === 'function') ? cap.getPlatform() : 'web';
  } catch {
    cachedPlatform = 'web';
  }
  return cachedPlatform;
}
